import type { ResolverOverride } from '@atlassian/jira-feature-flagging';
import { isVisualRefreshEnabled } from '../feature-switch/index.tsx';

const visualRefreshPlatformFlags = [
	'platform-component-visual-refresh',
	'platform-visual-refresh-icons',
];

export const visualRefreshResolverOverride: ResolverOverride = [
	(flagKey: string) => visualRefreshPlatformFlags.includes(flagKey),
	isVisualRefreshEnabled,
];
